// import router  from "./router";
import router,{resetRouter} from  './router'
import NProgress from "nprogress";
import { constantRouterComponents } from "./router";
/* 格式化后端结构信息并递归生成层级路由表 */
const generator = (routerMap, parent) => {
  return routerMap.map(item => {
    let tit= item.title
    let ptit=item.ptit
    let mates=item.btnpermissions
    const currentRouter = {
      // 路由地址 动态拼接生成如 /dashboard/workplace
      path: `/${parent && parent.name || ''}/${item.name}`,
      // 路由名称，建议唯一
      name: item.name || item.key || '',
      icon: item.icon || '',
      // 该路由对应页面的 组件
      component: constantRouterComponents[parent ? item.name : 'Layout'] ,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)  ,matas:mates?mates:item.meta.mates  item.meta.btnpermissions
      meta: {ptit:ptit?ptit:"",title:tit?tit:item.title,btnpermissions:mates?mates:item.meta}
    }
    // 重定向
    item.redirect && (currentRouter.redirect = item.redirect)
    // 是否有子菜单，并递归处理
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter)
    }
    // 为了防止出现后端返回结果不规范，处理有可能出现拼接出两个 反斜杠
    currentRouter.path = currentRouter.path.replace('//', '/')
    return currentRouter
  })
}
/* 路由守卫 */

let reAddRoutes = true
let getRouter
router.beforeEach((to, form, next) => {
  NProgress.start()
  if ((to.path !== '/404') && (to.path !== '/login')) {
    window.sessionStorage.setItem('path', to.path)
    window.sessionStorage.setItem('query', JSON.stringify(to.query))
  }
  if (!window.sessionStorage.getItem('userName') && to.path !== '/login') {
    return next({path: '/login'})
  }
  if((form.path !== '/login') && (to.path == '/login')){
    reAddRoutes=true
    sessionStorage.clear();
    resetRouter()
  }
  if (reAddRoutes && to.path !== '/login') {
    reAddRoutes = false
    let routerNav=JSON.parse(window.sessionStorage.getItem('nav'))
    getRouter = generator(routerNav) //过滤路由
    resetRouter()
    router.addRoutes(getRouter) //动态添加路由
    // console.log("***", layout);
    // console.log("***", getRouter);
    // console.log("***", router);
    // router.matcher = resetRouter().matcher
    next({path:window.sessionStorage.getItem('path')?window.sessionStorage.getItem('path'):"/home", query: JSON.parse(window.sessionStorage.getItem('query')),replace: true})
  }
  else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done();
});

export { router, generator };
